import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import SelectSearchDescriptionStatic from "@dropDesk/presentation/components/inputs/select_search_description_static";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputProblemSearch = observer(
    ({
         setFilterDescriptionStatic,
         filterDescriptionStatic,
         loading,
         hideLabel,
         size
     }: {
        setFilterDescriptionStatic: (filter: TicketsDescriptionStaticEntity | null, withList?: boolean) => void,
        filterDescriptionStatic: TicketsDescriptionStaticEntity | null,
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <>
                <Tooltip title={hideLabel ? 'Filtrar por problema' : undefined}>
                    <div style={{display: "flex", flex: 1}}>
                        <SelectSearchDescriptionStatic
                            size={size ?? 40}
                            useRemoveFilter={!!filterDescriptionStatic}
                            label={hideLabel ? undefined : 'Filtrar por Problema'}
                            placeHolder={"Pesquise por problema"}
                            handleSelectDescriptionStatic={(value, descriptionStatic) => {
                                setFilterDescriptionStatic(descriptionStatic ?? null);
                            }}
                            value={filterDescriptionStatic ? {
                                value: filterDescriptionStatic.id,
                                label: filterDescriptionStatic.description
                            } : undefined}
                            disabled={loading}
                            hideButtonNewDescriptionStatic={true}
                            iconLeftName={ICONS_DROPDESK.staticProblem}
                            borderColor={filterDescriptionStatic ? colors.accent : colors.border}
                        />
                    </div>
                </Tooltip>
            </>
        )
    })
export default InputProblemSearch;
